import { requests } from '../config'

export const Printouts = {
  getTeudaPdf: (deliveryNum: number, deliverySub: number): Promise<Blob> =>
    requests.get(`delivery/${deliveryNum}/${deliverySub}/pdf`, 'go', { responseType: 'blob' }),
}
